import { put, takeEvery, select } from 'redux-saga/effects';

import actions from './actions';
import pageActions from '../page/actions';
import groupActions from '../groups/actions';
import workflowActions from '../workflow/actions';
import fieldActions from '../fields/actions';
import uiActions from '../ui/actions';

import gtagSagas from './gtag/sagas';
import jquerySagas from './jquery/sagas';
import bottomlineSagas from './bottomline/sagas';

function* analyticsSendScreenviewGroup() {
  const { ui } = yield select();
  const { activeGroup } = ui;

  try {
    yield put(actions.analyticsSendScreenview(activeGroup));
  } catch (e) {
    // Do nothing
  }
}

function* analyticsSendScreenviewPage() {
  const { page } = yield select();
  const { name } = page;

  try {
    yield put(actions.analyticsSendScreenview(name));
  } catch (e) {
    // Do nothing
  }
}

function* oaoStart() {
  const { product } = yield select((state) => state.refs);
  try {
    yield put(actions.oaoStart(product));
  } catch (e) {
    // Do nothing
  }
}

function* oaoPageNav() {
  const { page } = yield select();
  const { name } = page;
  try {
    yield put(actions.oaoPageNav(name));
  } catch (e) {
    // Do nothing
  }
}

function* oaoServerError({ payload }) {
  try {
    const errorMsg =
      payload.data.result?.msgs?.['*'] ??
      payload.data?.msg ??
      payload.data?.meta?.msgs?.['*'] ??
      JSON.stringify(payload.data);
    yield put(actions.oaoServerError(`${payload.status} ${errorMsg}`));
  } catch (e) {
    // Do nothing
  }
}

function* oaoPageSubmit() {
  const { page } = yield select();
  const { name } = page;
  try {
    yield put(actions.oaoPageSubmit(name));
  } catch (e) {
    // Do nothing
  }
}

function* oaoPageSubmitSuccess() {
  const { page } = yield select();
  const { name } = page;
  try {
    yield put(actions.oaoPageSubmitSuccess(name));
  } catch (e) {
    // Do nothing
  }
}

function* oaoPageSubmitError() {
  const { page } = yield select();
  const { name } = page;
  try {
    yield put(actions.oaoPageSubmitError(name));
  } catch (e) {
    // Do nothing
  }
}

function* oaoGroup({ payload }) {
  const activeGroup = yield select((state) => state.ui.activeGroup);
  const groupName = payload.groupName ? payload.groupName : activeGroup;
  try {
    yield put(actions.oaoGroup(groupName));
  } catch (e) {
    // Do nothing
  }
}

function* oaoGroupNav() {
  const { ui } = yield select();
  const { activeGroup } = ui;
  try {
    yield put(actions.oaoGroupNav(activeGroup));
  } catch (e) {
    // Do nothing
  }
}

function* oaoGroupSubmit() {
  const { ui } = yield select();
  const { activeGroup } = ui;
  try {
    yield put(actions.oaoGroupSubmit(activeGroup));
  } catch (e) {
    // Do nothing
  }
}

function* oaoGroupSubmitError() {
  const { ui } = yield select();
  const { activeGroup } = ui;
  try {
    yield put(actions.oaoGroupSubmitError(activeGroup));
  } catch (e) {
    // Do nothing
  }
}

function* oaoFieldBlur({ payload }) {
  try {
    yield put(actions.oaoFieldBlur(payload));
  } catch (e) {
    // Do nothing
  }
}

function* oaoFieldError({ payload }) {
  try {
    yield put(actions.oaoFieldError(`${payload.fieldName}: ${payload.errorMsg}`));
  } catch (e) {
    // Do nothing
  }
}

function* oaoGooglePlacesAutocomplete({ payload }) {
  try {
    yield put(actions.oaoGooglePlacesAutocomplete(payload.clientIdPrefix));
  } catch (e) {
    // Do nothing
  }
}

export default [
  takeEvery(actions.GROUP, analyticsSendScreenviewGroup),
  takeEvery(actions.PAGE, analyticsSendScreenviewPage),
  takeEvery(workflowActions.START_SUCCESS, oaoStart),
  takeEvery(pageActions.GO, oaoPageNav),
  takeEvery(pageActions.GO_FAILED, oaoServerError),
  takeEvery(pageActions.NEXT, oaoPageSubmit),
  takeEvery(pageActions.NEXT_SUCCESS, oaoPageSubmitSuccess),
  takeEvery(pageActions.NEXT_FAILED, oaoPageSubmitError),
  takeEvery(groupActions.NEXT, oaoGroupNav),
  takeEvery(groupActions.NEXT, oaoGroupSubmit),
  takeEvery(groupActions.NEXT_FAILED, oaoGroupSubmitError),
  takeEvery(fieldActions.BLUR, oaoFieldBlur),
  takeEvery(fieldActions.SET_ERROR, oaoFieldError),
  takeEvery(fieldActions.GOOGLE_PLACES_AUTOCOMPLETE, oaoGooglePlacesAutocomplete),
  takeEvery([uiActions.SET_ACTIVE_GROUP, pageActions.GO_SUCCESS], oaoGroup),
  ...gtagSagas,
  ...jquerySagas,
  ...bottomlineSagas,
];
